/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable no-duplicate-imports */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect, ChangeEvent } from 'react';
import _ from 'lodash';
import { useParams } from 'react-router-dom';
import {
  Box,
  Table,
  Button,
  Dialog,
  Divider,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  IconButton,
  Typography,
  DialogActions,
  DialogContent,
  FormHelperText,
  TableContainer,
  Checkbox
} from '@mui/material';
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import { LoadingButton } from '@mui/lab';
import { API } from '../../../../../../api';
import InviteUserDialog from '../InviteUserDialog';
import ProgramUserDetails from './ProgramUserDetails';
import ProgramUserTableRow from './ProgramUserTableRow';
import ProgramInvitedUsers from './ProgramInvitedUsers';
import AppLoader from '../../../../../../components/AppLoader';
import { useLoader } from '../../../../components/useLoader';
import { adminPanel } from '../../../../../../utils/muiStyle';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { useModule } from '../../../../../../utils/useModule';
import upload from '../../../../../../assets/images/upload.svg';
import { getUserDetails } from '../../../../../../utils/orgName';
import { useProgramCreation } from '../../../../../../components/admin3/newProgram/ProgramCreationContext';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import {
  IGroupUser,
  fetchGroupUsers,
  groupUsersActions
} from '../../../../../../redux/slices/group-users/groupUsersSlice';
import LevelQuestionAnswers from '../../Dialogs/LevelQuestionAnswers';
import bulkupload from '../../../../../../assets/images/bulkupload.svg';
import downloadblue from '../../../../../../assets/images/downloadblue.svg';
import { useAppDispatch, useAppSelector } from '../../../../../../redux/hooks';
import { IAllTaskData } from '../../../../../../redux/slices/goals-tasks/getTasksSlice';
import CommonModalHeader from '../../../../../../components/DialogUi/CommonModalHeader';
import { fetchAllGroupsList } from '../../../../../../redux/slices/getAllGroupsListSlice';
import { getGoalProgressShowOrNot } from '../../../../components/common';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import DosenButton from '../../../../../../components/ui/Buttons/DosenButton';

const headerStyle = {
  borderBottom: "none",
  bgcolor: "#0F0F0F",
  color: "#868686",
  textTransform: "uppercase",
  fontSize: 12,
  fontWeight: 600,
  fontFamily: "Inter, sans-serif"
};


const HeaderSortable = ({
  title,
  field,
  onMouseEnter,
  onMouseLeave,
  onClick,
  filterType,
  selectedField,
  isHovered
}: any) => (
  <Box
    display="flex"
    alignItems="center"
    className="cursor-pointer"
    onMouseEnter={() => onMouseEnter(field)}
    onMouseLeave={onMouseLeave}
    onClick={() => onClick(field)}
  >
    {title}

    <ArrowUpwardIcon
      sx={{
        color: "#ABB5BE",
        width: 15,
        height: 15,
        ml: 0.5,
        opacity:
          (filterType === "ASC" && selectedField === field) ||
          (isHovered === field && (filterType !== "DESC" || selectedField !== field))
            ? 1
            : 0
      }}
    />

    <ArrowDownwardIcon
      sx={{
        color: "#ABB5BE",
        width: 15,
        height: 15,
        opacity: filterType === "DESC" && selectedField === field ? 1 : 0
      }}
    />
  </Box>
);


const ProgramUsers = () => {
  const params = useParams<{ id?: string; orgId?: string }>();
  const urlGrpId = params.id || '';
  const orgId = params.orgId || '';
  const { state } = useProgramCreation();
  const grpId = state.groupId || urlGrpId;
  const { isMasterclass, isMentorship } = useModule();
  const groupUsers = useAppSelector((state) => state.groupUsers);
  const [showProfile, setShowProfile] = useState(false);
  const groupDetails = useAppSelector((state) => state.groupDetails.data);
  const showCompany = groupDetails?.userOptionalFields?.companyName ? true : false;
  const [activeUserId, setActiveUserId] = useState('');
  const dispatch = useAppDispatch();

  const [openDialog, setOpenDialog] = React.useState(false);
  const [openUploadUsers, setOpenUploadUsers] = React.useState(false);
  const [bulkUserLoading, setBulkUserLoading] = useState(false);

  const [scrollToUserCall, setScrollToUserCall] = useState(false);
  const [closedUserId, setClosedUserId] = useState<any>(null);
  const [selectedField, setSelectedField] = useState('');
  const [filterType, setFilterType] = useState<'Normal' | 'ASC' | 'DESC'>('Normal');
  const [isHovered, setIsHovered] = useState('');
  const showGoalProgress =
    getGoalProgressShowOrNot(groupUsers.data?.showGoalProgress) && !isMentorship;
  const classs = adminPanel();
  const [viewAnswerOpen, setViewAnswerOpen] = useState(false);
  const [taskLoading, setTasksLoading] = useState(false);
  const [tasksData, setTasksData] = useState<IAllTaskData | null>(null);
  const handleViewAnswer = (flag: boolean) => setViewAnswerOpen(flag);
  

  /** Search */
  const [searchValue, setSearchValue] = useState('');

  // Mantém a mesma lógica de filtro por nome (mesmo sem input visual por enquanto)
  const filteredUsers =
    groupUsers.data?.users.filter((user) =>
      user.name.toLowerCase().includes(searchValue.toLowerCase())
    ) || [];

  const handleOpenTasks = async (userId: string) => {
    handleViewAnswer(true);
    setTasksLoading(true);
    try {
      const response = await API.getAllTasks({ grpId, userId });
      if (response.status === 200) {
        setTasksData(response.data);
        setTasksLoading(false);
      }
    } catch (e) {
      toast.error(_.get(e, 'response.data.message', 'Lessons failed to load'));
      setTasksLoading(false);
    }
  };

  const handleMouseEnter = (fieldName: string) => {
    setIsHovered(fieldName);
  };
  const handleMouseLeave = () => {
    setIsHovered('');
  };
  const handleUserClosedId = (userIds: any) => {
    setClosedUserId(userIds);
  };
  const handleClickOpenDialog = () => {
    setOpenDialog(true);
  };
  const handleClickUploadUsers = () => {
    setOpenUploadUsers(true);
  };
  const handleCloseUploadUsers = () => {
    setOpenUploadUsers(false);
    setErrorMessage('');
    setbulkFileName('');
  };

  /** Export Button */
  const handleClickExport = () => {
    // Mantém comportamento atual: apenas aviso
    toast.info('Export coming soon');
  };

  const [exportLoader, setExportLoader] = useState(false);
  const { location } = getUserDetails();
  const handleClickExportExcel = async (plan: boolean) => {
    toast.success('Your report will be emailed to you shortly');
    setExportLoader(true);
    try {
      await API.exportUsers({ grpId, location, orgId, plan });
    } catch (e) {
      toast.error(_.get(e, 'response.data.message', 'Report failed to export'));
    } finally {
      setExportLoader(false);
    }
  };

  const handleClickDevelopmentPlan = async (plan: boolean) => {
    toast.success('Your report will be emailed to you shortly');
    setExportLoader(true);
    try {
      await API.exportDevelopmentPlan({ grpId, location, orgId, plan });
    } catch (e) {
      toast.error(_.get(e, 'response.data.message', 'Report failed to export'));
    } finally {
      setExportLoader(false);
    }
  };

  const handleMemberDevelopmentPlan = (plan: boolean) => {
    handleClickDevelopmentPlan(plan);
  };

  

  /**  Upload Files in Bulk................... */
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [bulkfileName, setbulkFileName] = useState<string>('');

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleBulkFileChanges = (event: ChangeEvent<HTMLInputElement>) => {
    const selectFile = event.target.files?.[0];
    if (selectFile) {
      handleFileInputChange(selectFile);
    }
  };

  const handleDragEnter: React.DragEventHandler<HTMLElement> = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop: React.DragEventHandler<HTMLElement> = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const selectFile = event.dataTransfer.files;
    if (selectFile && selectFile[0]) {
      handleFileInputChange(selectFile[0]);
    }
  };

  const handleFileInputChange = (selectFile: File) => {
    const maxFileSize = 50 * 1024; // 50kb file size

    if (selectFile && selectFile.name.endsWith('.xlsx')) {
      if (selectFile.size > maxFileSize) {
        toast.error('The max file size is 50KB');
        return;
      } else {
        setbulkFileName(selectFile.name);
      }
    } else {
      toast.error('Only xlsx files can be uploaded');
      return;
    }
  };

  const [errorMessage, setErrorMessage] = useState<string>('');
  const handlebulkSubmit = async () => {
    setBulkUserLoading(true);
    if (bulkfileName) {
      const bulkFormData = new FormData();
      bulkFormData.append('xlsx', fileInputRef.current?.files?.[0] as File);

      try {
        const response = await API.bulkFilesUpload({
          data: bulkFormData,
          orgId,
          grpId
        });

        if (response.status === 200) {
          if (response.data.invitedUsers) {
            dispatch(fetchGroupUsers(grpId));
          }
          toast.success(_.get(response, 'data.message'));
          handleCloseUploadUsers();
          setBulkUserLoading(false);
        } else if (response.status === 207 && response.statusText === 'Multi-Status') {
          toast.success(_.get(response, 'data.message'));
          handleCloseUploadUsers();
          setBulkUserLoading(false);
        } else {
          toast.error('File failed to upload');
          handleCloseUploadUsers();
          setBulkUserLoading(false);
        }
      } catch (error) {
        setBulkUserLoading(false);
        toast.error('File failed to upload');
      }
    } else {
      setBulkUserLoading(false);
      setErrorMessage('*Please Choose a File to Upload.');
      return;
    }
  };

  // Download template
  const handleDownload = () => {
    const data = [
      ['First Name', 'Last Name', 'Email', 'Role'],
      ['oscar', 'robertson', 'oscarrobertson24@gmail.rcom', 'mentor'],
      ['Magic', 'johnson', 'johnmagic@gmail.com', 'mentee'],
      ['John', 'Smith', 'jsmith007@gmail.com', 'admin']
    ];

    const filename = 'template.xlsx';
    const sheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, 'Sheet1');
    XLSX.writeFile(workbook, filename);
  };

  useEffect(() => {
    if (grpId) {
      dispatch(fetchGroupUsers(grpId));
    }
  }, [dispatch, grpId]);

  useEffect(() => {
    if (grpId && orgId) {
      dispatch(fetchAllGroupsList({ orgId: orgId, groupId: grpId }));
    }
  }, [dispatch, grpId, orgId]);

  const [page, setPage] = useState(1);

  const showLoader = useLoader(groupUsers.loading, 1000);

  if (groupUsers.error) {
    return <Box>{groupUsers.errorText}</Box>;
  }

  let sortedUsers: any[] = [];

  const clickFilterHandle = (clickedField: string) => {
    let filterAppliedFlag = false;
    let filterTypeValue: 'Normal' | 'ASC' | 'DESC' = filterType;

    if (selectedField === clickedField) {
      if (filterType === 'Normal') {
        filterTypeValue = 'ASC';
      } else if (filterType === 'ASC') {
        filterTypeValue = 'DESC';
      } else {
        filterTypeValue = 'Normal';
      }
    } else {
      filterTypeValue = 'ASC';
    }

    setFilterType(filterTypeValue);
    setSelectedField(clickedField);

    if (!filterAppliedFlag) {
      filterAppliedFlag = true;
      if (filterTypeValue === 'Normal') {
        if (grpId) {
          dispatch(fetchGroupUsers(grpId));
        }
      } else {
        if (
          groupUsers.data &&
          (groupUsers.data.users.length > 0 || groupUsers.data.invitedUsers.length > 0)
        ) {
          // base
          sortedUsers = groupUsers.data.users.slice();

          // name filter
          if (clickedField === 'name') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = sortedUsers
                .slice()
                .sort((a, b) => a.name.localeCompare(b.name));
            } else {
              sortedUsers = sortedUsers
                .slice()
                .sort((a, b) => b.name.localeCompare(a.name));
            }
          }

          // messages count filter
          if (clickedField === 'messages') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) => b.sentMessages - a.sentMessages);
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) => a.sentMessages - b.sentMessages);
            }
          }

          // goal progress filter
          if (clickedField === 'goalProgress') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort(
                  (a, b) =>
                    (b.goalProgress ?? 0) - (a.goalProgress ?? 0)
                );
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort(
                  (a, b) =>
                    (a.goalProgress ?? 0) - (b.goalProgress ?? 0)
                );
            }
          }

          // Program role filter
          if (clickedField === 'role') {
            const rolePriority = {
              admin: 1,
              mentee: 2,
              mentor: 3
            };
            const getHighestRolePriority = (user: IGroupUser): number => {
              let minRolePriority = Number.MAX_SAFE_INTEGER;
              user.role.forEach((role) => {
                const priority =
                  rolePriority[role as keyof typeof rolePriority];
                if (priority < minRolePriority) {
                  minRolePriority = priority;
                }
              });
              return minRolePriority;
            };
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) => {
                  const highestRoleA = getHighestRolePriority(a);
                  const highestRoleB = getHighestRolePriority(b);
                  return highestRoleA - highestRoleB;
                });
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) => {
                  const highestRoleA = getHighestRolePriority(b);
                  const highestRoleB = getHighestRolePriority(a);
                  return highestRoleA - highestRoleB;
                });
            }
          }

          // xpPoints filter
          if (clickedField === 'xpPoints') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort(
                  (a, b) =>
                    (b.xpPoints ?? 0) - (a.xpPoints ?? 0)
                );
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort(
                  (a, b) =>
                    (a.xpPoints ?? 0) - (b.xpPoints ?? 0)
                );
            }
          }

          // lastLogin filter
          if (clickedField === 'lastLogin') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) => b.lastLogin - a.lastLogin);
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) => a.lastLogin - b.lastLogin);
            }
          }

          // meetings filter
          if (clickedField === 'meetings') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) => b.meetings - a.meetings);
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) => a.meetings - b.meetings);
            }
          }

          // onboardingStatus filter
          if (clickedField === 'onboardingStatus') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) =>
                  a.onboardStatus === 'engaged' && isMasterclass
                    ? 'adopted'.localeCompare(b.onboardStatus)
                    : a.onboardStatus.localeCompare(b.onboardStatus)
                );
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) =>
                  b.onboardStatus === 'engaged' && isMasterclass
                    ? 'adopted'.localeCompare(a.onboardStatus)
                    : b.onboardStatus.localeCompare(a.onboardStatus)
                );
            }
          }

          if (clickedField === 'onboardedDate') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort(
                  (a, b) =>
                    new Date(a.onboardedDate).getTime() -
                    new Date(b.onboardedDate).getTime()
                );
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort(
                  (a, b) =>
                    new Date(b.onboardedDate).getTime() -
                    new Date(a.onboardedDate).getTime()
                );
            }
          }

          if (clickedField === 'company') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) =>
                  (a.company?.companyName || '').localeCompare(
                    b.company?.companyName || ''
                  )
                );
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) =>
                  (b.company?.companyName || '').localeCompare(
                    a.company?.companyName || ''
                  )
                );
            }
          }

          if (clickedField === 'location') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) =>
                  (a.company?.companyLocation || '').localeCompare(
                    b.company?.companyLocation || ''
                  )
                );
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) =>
                  (b.company?.companyLocation || '').localeCompare(
                    a.company?.companyLocation || ''
                  )
                );
            }
          }

          dispatch(groupUsersActions.updateGroupUserList(sortedUsers));
        }
      }
    }
  };
const headerSortProps = {
  onMouseEnter: handleMouseEnter,
  onMouseLeave: handleMouseLeave,
  onClick: clickFilterHandle,
  filterType,
  selectedField,
  isHovered
};
  const itemsPerPage = 25;
  const totalPages = 10;

  const handlePageChange = (newPage: number) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const totalMembers =
    (groupUsers.data?.users?.length || 0) +
    (groupUsers.data?.invitedUsers?.length || 0);
  const membersLabel = `${totalMembers} ${
    totalMembers === 1 ? 'Member' : 'Members'
  }`;

  if (groupUsers.data) {
    sortedUsers = groupUsers.data.users;

    return (
      <>
        {showLoader ? (
          <AppLoader />
        ) : (
          <Box className={classs.mainBody}>
            {showProfile ? (
              <ProgramUserDetails
                actievUserId={activeUserId}
                setScrollToUserCall={setScrollToUserCall}
                setShowProfile={setShowProfile}
                grpId={grpId}
                handleUserClosedId={handleUserClosedId}
                handleOpenTasks={handleOpenTasks}
              />
            ) : (
              <Box
                sx={{
                  height: '100%',
                  bgcolor: '#0F0F0F',
                  borderRadius: '8px',
                  border: '1px solid #2A2A2A',
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                {/* HEADER – Figma style */}
                <Box
                  sx={{
                    px: 3,
                    py: 2.5,
                    height: 82,
                    borderBottom: '1px solid #1C1C1C',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2
                  }}
                >
                  {/* Checkbox fake (select all) */}
                  <Box
                    sx={{
                      width: 22,
                      height: 22,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <Checkbox
                      size="small"
                      sx={{
                        width: 22,
                        height: 22,
                        p: 0,
                        '& .MuiSvgIcon-root': {
                          fontSize: 18
                        },
                        color: '#868686'
                      }}
                    />
                  </Box>

                  {/* Members count */}
                  <Box
                    sx={{
                      flex: '1 1 0',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <Typography
                      sx={{
                        color: '#B6B6B6',
                        fontSize: 16,
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 600
                      }}
                    >
                      {membersLabel}
                    </Typography>
                  </Box>

                  {/* Right buttons */}
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1.25
                    }}
                  >
                    {/* Export Data */}
                    {/* <Button
                      onClick={handleClickExport}
                      disabled={exportLoader}
                      sx={{
                        textTransform: 'none',
                        px: 1.75,
                        py: 1.25,
                        borderRadius: '6px',
                        bgcolor: '#1C1C1C',
                        color: '#FDFDFD',
                        fontSize: 13,
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 500,
                        lineHeight: '19.5px',
                        '&:hover': {
                          bgcolor: '#262626'
                        }
                      }}
                    >
                      Export Data
                    </Button> */}

                    {/* Manual Invite */}
                    <Button
                      onClick={handleClickOpenDialog}
                      sx={{
                        textTransform: 'none',
                        px: 1.5,
                        py: 1.25,
                        borderRadius: '6px',
                        bgcolor: '#565656',
                        color: '#FDFDFD',
                        fontSize: 13,
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 500,
                        lineHeight: '19.5px',
                        border: '1px solid #0F0F0F',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.75,
                        '&:hover': {
                          bgcolor: '#666666'
                        }
                      }}
                    >
                      <ForwardToInboxIcon />
                      Manual Invite
                    </Button>

                    {/* Auto-Invite (Bulk upload) */}
                    <Button
                      onClick={handleClickUploadUsers}
                      sx={{
                        textTransform: 'none',
                        px: 1.5,
                        py: 1.25,
                        borderRadius: '6px',
                        background:
                          'linear-gradient(180deg, #F79420 0%, #F15A26 100%)',
                        color: '#FDFDFD',
                        fontSize: 13,
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 600,
                        lineHeight: '19.5px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.75,
                        '&:hover': {
                          background:
                            'linear-gradient(180deg, #FFA63E 0%, #F46B38 100%)'
                        }
                      }}
                    >
                     <GroupAddIcon />
                     Bulk Invite
                    </Button>
                  </Box>
                </Box>

                {/* TABLE */}
                <TableContainer
                  className="b-none"
                  sx={{
                    flex: 1,
                    bgcolor: '#0F0F0F'
                  }}
                >
                  <Table
                    className="tableBody"
                    width="100%"
                    aria-label="members table"
                  >
                    {/* HEADER ROW – adaptado pro layout Figma */}
                    <TableHead>
  <TableRow sx={{ bgcolor: "#0F0F0F", height: 48 }}>
    {/* 1 — Checkbox */}
    <TableCell sx={{ width: 22 }} />

    {/* 2 — NAME (flex no figma, mas usamos width fixa equivalente) */}
    <TableCell sx={{ width: 240 }}>
      <Typography className="uppercase" sx={{ color: "#868686", fontSize: 12, fontWeight: 600 }}>
        Name
      </Typography>
    </TableCell>

    {/* 3 — ROLE */}
    <TableCell sx={{ width: 240 }}>
      <Typography className="uppercase" sx={{ color: "#868686", fontSize: 12, fontWeight: 600 }}>
        Role
      </Typography>
    </TableCell>

    {/* 4 — Last Login */}
    <TableCell sx={{ width: 180 }}>
      <Typography className="uppercase" sx={{ color: "#868686", fontSize: 12, fontWeight: 600 }}>
        Last Login
      </Typography>
    </TableCell>

    {/* 5 — Programs */}
    <TableCell sx={{ width: 80 }}>
      <Typography className="uppercase" sx={{ textAlign: "center", color: "#868686", fontSize: 12, fontWeight: 600 }}>
        Programs
      </Typography>
    </TableCell>

    {/* 6 — Onboarding Status */}
    <TableCell sx={{ width: 150 }}>
      <Typography className="uppercase" sx={{ color: "#868686", fontSize: 12, fontWeight: 600 }}>
        Onboarding Status
      </Typography>
    </TableCell>

    {/* 7 — Onboarded Date */}
    <TableCell sx={{ width: 150 }}>
      <Typography className="uppercase" sx={{ color: "#868686", fontSize: 12, fontWeight: 600 }}>
        Onboarded Date
      </Typography>
    </TableCell>

    {/* 8 — Goal Progress */}
    <TableCell sx={{ width: 140 }}>
      <Typography className="uppercase" sx={{ color: "#868686", fontSize: 12, fontWeight: 600 }}>
        Goal Progress
      </Typography>
    </TableCell>

    {/* 9 — Experience Points */}
    <TableCell sx={{ width: 150 }}>
      <Typography className="uppercase" sx={{ color: "#868686", fontSize: 12, fontWeight: 600 }}>
        Experience Points
      </Typography>
    </TableCell>

    {/* 10 — Meetings */}
    <TableCell sx={{ width: 100 }}>
      <Typography className="uppercase" sx={{ color: "#868686", fontSize: 12, fontWeight: 600 }}>
        Meetings
      </Typography>
    </TableCell>

    {/* 11 — Actions */}
    <TableCell sx={{ width: 50 }} />
  </TableRow>
</TableHead>


                    <TableBody>
                      {/* User Rows */}
                      {groupUsers.data &&
                      (groupUsers.data.users.length > 0 ||
                        groupUsers.data.invitedUsers.length > 0) ? (
                        filteredUsers.map((each: IGroupUser) => {
                          return (
                            <ProgramUserTableRow
                              key={each.userId}
                              data={each}
                              setShowProfile={setShowProfile}
                              setActiveUserId={setActiveUserId}
                              scrollToUserCall={scrollToUserCall}
                              setScrollToUserCall={setScrollToUserCall}
                              closedUserId={closedUserId}
                              showGoalProgress={showGoalProgress}
                              handleOpenTasks={handleOpenTasks}
                              showCompany={showCompany}
                            />
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell colSpan={22}>
                            <Typography textAlign="center" color="#868686">
                              No members have been invited to this program yet
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}

                      {/* Invited Users */}
                      {groupUsers.data.invitedUsers &&
                        groupUsers.data.invitedUsers.length > 0 &&
                        groupUsers.data.invitedUsers.map((each) => (
                          <React.Fragment key={each.userId}>
                            <ProgramInvitedUsers
                              data={each}
                              showCompany={showCompany}
                              showGoalProgress={showGoalProgress}
                            />
                          </React.Fragment>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}
          </Box>
        )}

        {/* Invite user dialog */}
        <InviteUserDialog
          handleClose={handleCloseUploadUsers}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          type="Add"
        />

        {/*  Bulk upload members */}
        <Dialog open={openUploadUsers} onClose={handleCloseUploadUsers} scroll="body" fullWidth>
          <CommonModalHeader
            title="Bulk upload members"
            handleCloseModal={handleCloseUploadUsers}
          />
          <DialogContent sx={{backgroundColor: 'black', color: 'white'}}>
            <Typography>
              In order to bulk upload members, please download the template file
              to proceed. <br /> First name, last name, email address, and role
              are required.
            </Typography>
            <Box
              display="flex"
              alignItems="center"
              gap="8px"
              my={2}
            >
              <img
                src={downloadblue}
                alt="downloadblueimg"
                width="21"
                height="21"
                className="cursor-pointer"
                onClick={handleDownload}
              />
              <Typography
                className="cursor-pointer"
                variant="subtitle2"
                color="#0071A9"
                onClick={handleDownload}
              >
                Download bulk upload template
              </Typography>
            </Box>
            <Box
              p={2.5}
              borderRadius="8px"
              bgcolor="black"
              border="1px dashed #DEDFDF"
              className="cursor-pointer"
              onClick={handleButtonClick}
            >
              <Box
                textAlign="center"
                onDragEnter={handleDragEnter}
                onDragOver={handleDragEnter}
                onDrop={handleDrop}
              >
                <IconButton>
                  <img src={upload} alt="upload" width="25" height="25" />
                </IconButton>
                <input
                  ref={fileInputRef}
                  type="file"
                  className="d-none"
                  placeholder="file"
                  accept=".xlsx"
                  onChange={handleBulkFileChanges}
                />
                <Box>
                  <p className="fs-12 secondary-light fw-600">
                    <span className="text-blue fs-14">Click to upload </span>
                    or drag <br /> Excel file only (max. 50 KB) <br />
                  </p>
                  {bulkfileName ? (
                    <Typography
                      mt={1}
                      variant="h5"
                      style={{ color: 'green' }}
                    >
                      {bulkfileName}
                    </Typography>
                  ) : (
                    <FormHelperText
                      error
                      sx={{ textAlign: 'center' }}
                    >
                      {errorMessage}
                    </FormHelperText>
                  )}
                </Box>
              </Box>
            </Box>
          </DialogContent>

          <DialogActions sx={{p: 4, backgroundColor: 'black'}}>
            <DosenButton
              // color="primary"
              // variant="contained"
              fullWidth
              onClick={handlebulkSubmit}
              loading={bulkUserLoading}
            >
              Add
            </DosenButton>
          </DialogActions>
        </Dialog>

        <LevelQuestionAnswers
          open={viewAnswerOpen}
          setOpen={setViewAnswerOpen}
          taskLoading={taskLoading}
          tasksData={tasksData}
        />
      </>
    );
  }
  return null;
};

export default ProgramUsers;
